import './App.css';
import Main from './Components/Main';
import Nav from './Components/Nav';
import About from "./Components/About";
import { Route, Routes } from "react-router-dom";
import Projects from './Components/Projects';
import Contact from './Components/Contact';
import Azeemo from './Images/azeemo_tcg.png';
import Popmart from './Images/azeemo_popmart.png';
import NextBuy from './Images/nextbuy.png';
import ArtUnltd from './Images/art_unltd.png';
import CssFX from './Images/cssfx.gif';
import ConcertArchive from './Images/concert_archive.png';

function App() {

  const all_projects = [
  {
    img:NextBuy, 
    title:"NextBuy", 
    gitLink:"https://github.com/r-shahid/nextbuy", 
    siteLink:"https://nextbuy-n7uf.onrender.com/"
  },
  {
    img:ArtUnltd, 
    title:"Art Unlimited",  
    gitLink:"https://github.com/r-shahid/art-app/", 
    siteLink:"https://art-unlimited.netlify.app/"
  },
  { 
    img:Azeemo, 
    title:"AzeemoTCG", 
    subtitle: "Site & Logo Design",
    gitLink:"https://github.com/r-shahid/azeemo", 
    siteLink:"https://azeemo.netlify.app/"
  },
  {
    img:Popmart, 
    title:"PopMart Inventory", 
    gitLink:"https://github.com/r-shahid/popmart-stock", 
    siteLink:"https://azeemotcg-popmart.netlify.app/"
  },
  {
    img:CssFX, 
    title:"CSS FX", 
    gitLink:"https://github.com/r-shahid/css", 
    siteLink:"https://cssfx-rs.netlify.app/"
  },
  {
    img:ConcertArchive, 
    title:"Riana's Concert Archive",  
    gitLink:"https://github.com/r-shahid/concert", 
    siteLink:"https://concerts.rianashahid.com"
  }
  
  // ,
  // {
  //   id:7,
  //   img:Azeemo, //add image here
  //   title:"Notes & ToDo App",  
  //   gitLink:"https://github.com/r-shahid/a5-clone", 
  //   siteLink:"https://notes-rs.netlify.app/"
  // }
]

  // const small_projects =[
  //   {
  //     id: 1,
  //     img: "",
  //     title: "CSS FX",
  //     gitLink: "https://github.com/r-shahid/css",
  //     siteLink: "https://github.com/r-shahid/css"
  //   },
  //   {
  //     id: 2,
  //     img: "",
  //     title: "Mondrian Grid",
  //     gitLink: "https://github.com/r-shahid/mondrian",
  //     siteLink: "https://github.com/r-shahid/mondrian"
  //   }
  // ]

  return (
    <div className="App">
      <header className="App-header">
        <Nav />
      </header>
      <Routes>
      <Route exact path="/" element={<Main all_projects={all_projects} />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects all_projects={all_projects} />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </div>
  );
}

export default App;
